import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import {
	calendar,
	currencyDollarCircle,
	hourglass_01,
} from "@tql/ui-components-react/untitled/icons";
import { useMemo } from "react";

import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import type { InvoiceFilter } from "~/shared/types/payment-types.ts";

import { useGetPaymentSummary } from "../hooks/use-get-payment-summary.ts";
import { SummaryCards } from "../summary-cards/index.tsx";

type PaymentHeaderProps = {
	onFilterChange: (filter: InvoiceFilter) => void;
	selectedFilter?: InvoiceFilter | null;
};

export function PaymentHeader({
	onFilterChange,
	selectedFilter,
}: Readonly<PaymentHeaderProps>) {
	const { summary, isLoading } = useGetPaymentSummary();

	const summaryData = useMemo(() => {
		return {
			pastDueAmount: {
				amount: summary?.pastDueAmount.sum ?? 0,
				icon: <SvgIcon icon={hourglass_01} size={"xxlarge"} />,
				count: summary?.pastDueAmount.count ?? 0,
				label: "Past Due",
			},
			dueSoonAmount: {
				amount: summary?.dueSoonAmount.sum ?? 0,
				icon: <SvgIcon icon={calendar} size={"xxlarge"} />,
				count: summary?.dueSoonAmount.count ?? 0,
				label: "Due Soon",
			},
			outstandingBalance: {
				amount: summary?.outstandingBalance.sum ?? 0,
				icon: <SvgIcon icon={currencyDollarCircle} size={"xxlarge"} />,
				count: summary?.outstandingBalance.count ?? 0,
				label: "Outstanding Balance",
			},
		};
	}, [summary]);

	return isLoading ? (
		<LoadingSpinner />
	) : (
		<SummaryCards
			data={summaryData}
			handleFilterChange={onFilterChange}
			selectedFilter={selectedFilter}
		/>
	);
}
